// extracted by mini-css-extract-plugin
export default {"button":"PlayButton_button__VsifI","play_icon":"PlayButton_play_icon__i2WUz","text":"PlayButton_text__xmiIF"};